/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedFrequentlyAskedQuestions_buyPage = {
    readonly frequentlyAskedQuestions: ReadonlyArray<{
        readonly question: string | null;
        readonly answer: string | null;
    } | null> | null;
    readonly " $refType": "BuySharedFrequentlyAskedQuestions_buyPage";
};
export type BuySharedFrequentlyAskedQuestions_buyPage$data = BuySharedFrequentlyAskedQuestions_buyPage;
export type BuySharedFrequentlyAskedQuestions_buyPage$key = {
    readonly " $data"?: BuySharedFrequentlyAskedQuestions_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedFrequentlyAskedQuestions_buyPage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedFrequentlyAskedQuestions_buyPage",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "frequentlyAskedQuestions",
      "storageKey": null,
      "args": null,
      "concreteType": "BuyPageFrequentlyAskedQuestionType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "question",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "answer",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c224deaedd09184ea0a9c06d7e00aaff';
export default node;
